<template>
    <div class="talent-level-container">
        <div class="box">
            <div class="control">
                <span class="name">创作时间</span>
                <el-date-picker
                        size="small"
                        v-model="search.startTime"
                        type="datetime"
                        align="right">
                </el-date-picker>
                <span class="r-top">~</span>
                <el-date-picker
                        size="small"
                        v-model="search.endTime"
                        type="datetime"
                        align="right">
                </el-date-picker>
            </div>
            <button class='button is-primary' @click="doSearch">搜索</button>

        </div>
        <div class="list-wrap">
            <div class="clearfix">
                <el-pagination
                        v-if="count>0"
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
            <div class="is-parent clearfix flex">
                <article class="box poster" v-for="(item,index) in list">
                    <div>
                        <img :src="item.image.image" style="width: 300px">
                    </div>
                    <div class="clearfix">
                        <span class="fleft name">{{item.username}}</span>
                        <span class="fright">{{item.createTime}}</span>
                    </div>
                </article>
            </div>
            <div class="clearfix">
                <el-pagination
                        v-if="count>0"
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
  import { getTimeByDateStr } from 'UTILS/date'
  import {formatDFSUrl} from 'UTILS/_url'



  export default {
    data(){
      return {
        search: {
          page: 1,
          pageSize: 20,
          startTime:null,
          endTime:null,
        },
        list: [],
        count: 0,
      }
    },
    mounted(){
      this.getList()
    },
    methods: {
      handleCurrentChange(value) {
        if(this.search.page !== value){
          this.search.page = value
          this.getList()
        }
      },
      getList(){
        let params = Object.assign({},this.search);
        if(params.startTime){
          params.startTime = getTimeByDateStr(params.startTime)
        }
        if(params.endTime){
          params.endTime = getTimeByDateStr(params.endTime)

        }
        HttpRequest.get('/admin.php?method=miniprogram.getIcy618DrawList', params).then(response => {
          this.list = _.toArray(response.data.list)
          this.count = parseInt(response.data.count)
          _.each(this.list,(item,index)=>{
            item.image.image=formatDFSUrl(item.image.image)
          })
        })
      },
      doSearch(){
        this.getList()
      },
    },
  }
</script>
<style lang="less" scoped>
    .poster{
        margin:10px 10px;
    }
    .name{
        font-weight: bold;
        color: #333;
    }
    .flex {
        display: flex;
        flex-wrap: wrap;
    }
</style>
